var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { staticStyle: { overflow: "hidden" }, attrs: { column: "", wrap: "" } },
    [
      _vm.activeTab === 0
        ? _c("div", {
            staticStyle: {
              "background-color": "#191a1c",
              height: "80px",
              width: "240px",
              "z-index": "8",
              position: "absolute",
              left: "3.7%",
              top: "58px"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { id: "nodeLegend" } },
        [
          _vm.activeTab === 0
            ? _c(
                "v-layout",
                [
                  _c("v-layout", { attrs: { column: "" } }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "200px",
                          "text-align": "center",
                          border: "1px solid #fff",
                          padding: "10px"
                        }
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "mx-2",
                            staticStyle: {
                              "font-size": "13px",
                              "text-transform": "uppercase",
                              color: "#fff"
                            },
                            attrs: { dark: "" }
                          },
                          [_vm._v("title: " + _vm._s(_vm.storyTitle))]
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.nodesTitleLegend, function(item) {
                    return _c(
                      "v-flex",
                      { key: item.name },
                      [
                        _c(
                          "v-btn",
                          {
                            staticStyle: { "margin-bottom": "0" },
                            attrs: {
                              slot: "activator",
                              disabled: item.disabled,
                              id: "addNode",
                              round: "",
                              small: "",
                              flat: "",
                              color: item.color
                            },
                            on: {
                              click: function($event) {
                                return _vm.addNode(item.name)
                              }
                            },
                            slot: "activator"
                          },
                          [
                            _vm._v("\n          " + _vm._s(item.name)),
                            _c(
                              "v-icon",
                              {
                                staticClass: "ml-1",
                                staticStyle: { "font-size": "13px" },
                                attrs: { color: item.color }
                              },
                              [_vm._v("fas " + _vm._s(item.icon))]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-btn",
                        {
                          staticStyle: { "background-color": "#121212" },
                          attrs: {
                            slot: "activator",
                            round: "",
                            color: "#FF9D42",
                            flat: "",
                            small: ""
                          },
                          on: {
                            click: function($event) {
                              _vm.showStories = true
                            }
                          },
                          slot: "activator"
                        },
                        [_vm._v("\n                Import\n            ")]
                      )
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      [
        _c("v-spacer", { staticStyle: { height: "48px !important" } }),
        _vm._v(" "),
        _vm.savedTree
          ? _c(
              "v-flex",
              {
                staticStyle: {
                  position: "absolute",
                  "z-index": "11",
                  right: "580px",
                  top: "10px"
                },
                attrs: { "offset-3": "" }
              },
              [
                _c("v-icon", { attrs: { color: "#08d43f" } }, [
                  _vm._v("folder_open")
                ]),
                _vm._v(" "),
                _c("span", { staticStyle: { color: "#08d43f" } }, [
                  _vm._v("All your changes are saved")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.exportedJson
          ? _c(
              "v-flex",
              {
                staticStyle: {
                  position: "absolute",
                  "z-index": "11",
                  right: "580px",
                  top: "10px"
                },
                attrs: { "offset-3": "" }
              },
              [
                _c("v-icon", { attrs: { color: "#08d43f" } }, [
                  _vm._v("cloud_upload")
                ]),
                _vm._v(" "),
                _c("span", { staticStyle: { color: "#08d43f" } }, [
                  _vm._v("Exported your story")
                ])
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        [
          _c(
            "v-tooltip",
            {
              staticStyle: { "z-index": "999" },
              attrs: { right: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            staticStyle: {
                              margin: "0px auto 5px auto",
                              width: "40px",
                              "min-width": "0px !important"
                            },
                            attrs: {
                              slot: "activator",
                              color: "#909090",
                              flat: "",
                              small: ""
                            },
                            on: { click: _vm.saveTreeToDB },
                            slot: "activator"
                          },
                          on
                        ),
                        [_c("v-icon", {}, [_vm._v("folder_open")])],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [_vm._v(" "), _c("span", [_vm._v("Save")])]
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            {
              staticStyle: { "z-index": "999" },
              attrs: { right: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            staticStyle: {
                              margin: "0px auto 5px auto",
                              width: "40px",
                              "min-width": "0px !important"
                            },
                            attrs: {
                              slot: "activator",
                              color: "#909090",
                              flat: "",
                              small: ""
                            },
                            on: { click: _vm.exportFile },
                            slot: "activator"
                          },
                          on
                        ),
                        [_c("v-icon", {}, [_vm._v("cloud_upload")])],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [_vm._v(" "), _c("span", [_vm._v("Upload JSON")])]
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            {
              staticStyle: { "z-index": "999" },
              attrs: { right: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            staticStyle: {
                              margin: "auto",
                              width: "40px",
                              "min-width": "0px !important"
                            },
                            attrs: {
                              slot: "activator",
                              color: "#909090",
                              flat: "",
                              small: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.share = !_vm.share
                              }
                            },
                            slot: "activator"
                          },
                          on
                        ),
                        [_c("v-icon", [_vm._v("share")])],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [_vm._v(" "), _c("span", [_vm._v("share")])]
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500" },
              model: {
                value: _vm.share,
                callback: function($$v) {
                  _vm.share = $$v
                },
                expression: "share"
              }
            },
            [_c("share-card", { attrs: { "story-i-d": _vm.storyID } })],
            1
          ),
          _vm._v(" "),
          _c("v-spacer", { staticStyle: { height: "360px !important" } }),
          _vm._v(" "),
          [
            _c(
              "v-tooltip",
              {
                attrs: { right: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              staticStyle: {
                                margin: "0px auto 5px auto",
                                width: "40px",
                                "min-width": "0px !important"
                              },
                              attrs: {
                                slot: "activator",
                                color: "#909090",
                                flat: "",
                                small: ""
                              },
                              slot: "activator"
                            },
                            on
                          ),
                          [
                            _c(
                              "v-icon",
                              { staticStyle: { "font-size": "20px" } },
                              [_vm._v("far fa-clone")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              },
              [_vm._v(" "), _c("span", [_vm._v("Duplicate")])]
            ),
            _vm._v(" "),
            _c(
              "v-tooltip",
              {
                attrs: { right: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              staticStyle: {
                                margin: "0px auto 5px auto",
                                width: "40px",
                                "min-width": "0px !important"
                              },
                              style: {
                                opacity: _vm.selectedAnimation ? 1.0 : 0.5
                              },
                              attrs: {
                                slot: "activator",
                                color: "#909090",
                                flat: "",
                                small: ""
                              },
                              on: { click: _vm.removeAnimation },
                              slot: "activator"
                            },
                            on
                          ),
                          [
                            _c(
                              "v-icon",
                              { staticStyle: { "font-size": "20px" } },
                              [_vm._v("far fa-trash-alt")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              },
              [_vm._v(" "), _c("span", [_vm._v("Delete")])]
            ),
            _vm._v(" "),
            _c("v-divider", {
              staticStyle: { border: "1px solid #121212", margin: "10px auto" }
            }),
            _vm._v(" "),
            _c(
              "v-tooltip",
              {
                attrs: { right: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              staticStyle: {
                                margin: "0px auto 5px auto",
                                width: "40px",
                                "min-width": "0px !important"
                              },
                              attrs: {
                                slot: "acivator",
                                color: "#909090",
                                flat: "",
                                small: ""
                              },
                              slot: "acivator"
                            },
                            on
                          ),
                          [
                            _c(
                              "v-icon",
                              { staticStyle: { "font-size": "20px" } },
                              [_vm._v("fas fa-arrows-alt-v")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              },
              [_vm._v(" "), _c("span", [_vm._v("Vertical Expansion")])]
            ),
            _vm._v(" "),
            _c(
              "v-tooltip",
              {
                attrs: { right: "" },
                scopedSlots: _vm._u([
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            {
                              staticStyle: {
                                margin: "auto",
                                width: "40px",
                                "min-width": "0px !important"
                              },
                              attrs: {
                                slot: "activator",
                                color: "#909090",
                                flat: "",
                                small: ""
                              },
                              slot: "activator"
                            },
                            on
                          ),
                          [
                            _c(
                              "v-icon",
                              { staticStyle: { "font-size": "20px" } },
                              [_vm._v("fas fa-arrows-alt-h")]
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              },
              [_vm._v(" "), _c("span", [_vm._v("Horizontal Expansion")])]
            )
          ]
        ],
        _vm._v(" "),
        _c(
          "v-dialog",
          {
            staticStyle: { overflow: "scroll" },
            attrs: { "max-width": "430", id: "#pasteStoryDialog" },
            model: {
              value: _vm.showStories,
              callback: function($$v) {
                _vm.showStories = $$v
              },
              expression: "showStories"
            }
          },
          [
            _c(
              "v-card",
              {
                staticStyle: { height: "auto !important", overflow: "scroll" },
                attrs: { "max-height": "auto" }
              },
              [
                _c(
                  "v-btn",
                  {
                    staticStyle: {
                      position: "absolute",
                      right: "15px",
                      top: "25px"
                    },
                    attrs: { icon: "", dark: "" },
                    on: {
                      click: function($event) {
                        _vm.showStories = false
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { color: "grey" } }, [
                      _vm._v("close")
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { id: "importStoryTitleBg" } },
                  [
                    _c("v-card-title", { attrs: { id: "importStoryTitle" } }, [
                      _vm._v(" Import story")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "#949494",
                        attrs: { id: "importStoryDialogDescription" }
                      },
                      [_vm._v(" Import your story from your list.")]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-container",
                  { staticStyle: { padding: "0" } },
                  [
                    _c(
                      "v-flex",
                      {
                        staticStyle: {
                          "padding-left": "5%",
                          width: "90%",
                          "margin-top": "20px",
                          "margin-bottom": "10px"
                        }
                      },
                      [
                        _c("span", { attrs: { id: "storyListTitle" } }, [
                          _vm._v("story List")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.stories, function(story, index) {
                      return _c("v-flex", { key: index }, [
                        _c(
                          "div",
                          { staticClass: "text-xs-center" },
                          [
                            _c("v-layout", { attrs: { row: "" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { id: "importBtn" }
                                },
                                [
                                  story.title.length <= 25
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            position: "absolute",
                                            "padding-left": "3%",
                                            "padding-top": "5px"
                                          }
                                        },
                                        [_vm._v(_vm._s(story.title))]
                                      )
                                    : _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            position: "absolute",
                                            "padding-left": "5%",
                                            "padding-top": "5px"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              story.title.substr(0, 25) + "..."
                                            )
                                          )
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "v-btn",
                                    {
                                      staticStyle: {
                                        "margin-left": "65%",
                                        "background-color": "#3F51B5",
                                        color: "#fff",
                                        "text-decoration": "none",
                                        "border-radius": "20px"
                                      },
                                      attrs: { small: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.showSelectedStoryNodes(
                                            story.diagramData
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("import")]
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ])
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _c("v-card-actions", [
                  _c("div", { staticClass: "flex-grow-1" })
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "v-dialog",
          {
            attrs: { "max-width": "430" },
            model: {
              value: _vm.showSelectedStoryNodesDialog,
              callback: function($$v) {
                _vm.showSelectedStoryNodesDialog = $$v
              },
              expression: "showSelectedStoryNodesDialog"
            }
          },
          [
            _c(
              "v-card",
              {
                staticStyle: {
                  "background-color": "#EEEEEE",
                  height: "420px",
                  overflow: "scroll !important"
                }
              },
              [
                _c(
                  "v-container",
                  {
                    staticClass: "pa-0",
                    staticStyle: { "margin-top": "20px" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "background-color": "#e0e0e0",
                          padding: "20px",
                          width: "100%"
                        }
                      },
                      [
                        _c("span", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v("Story Nodes")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "grey--text",
                            staticStyle: {
                              "font-size": "15px",
                              "margin-bottom": "30px"
                            }
                          },
                          [_vm._v("Select all nodes to import")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-container",
                      { staticStyle: { width: "85%" } },
                      [
                        _c("v-select", {
                          attrs: {
                            items: _vm.nodeDataArray,
                            "item-text": "title",
                            "return-object": "",
                            attach: "",
                            chips: "",
                            label: "nodes",
                            multiple: ""
                          },
                          model: {
                            value: _vm.nodesWaitedToBePasted,
                            callback: function($$v) {
                              _vm.nodesWaitedToBePasted = $$v
                            },
                            expression: "nodesWaitedToBePasted"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-container",
                  {
                    staticStyle: {
                      width: "90%",
                      "text-align": "right",
                      "padding-top": "120px"
                    }
                  },
                  [
                    _c(
                      "v-btn",
                      {
                        staticStyle: {
                          "background-color": "#3F51B5",
                          color: "#fff",
                          "border-radius": "20px"
                        },
                        attrs: { small: "" },
                        on: { click: _vm.importNodes }
                      },
                      [_vm._v("Import")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-btn",
                      {
                        staticStyle: {
                          border: "1px solid grey",
                          color: "grey",
                          "border-radius": "20px"
                        },
                        attrs: { small: "" },
                        on: {
                          click: function($event) {
                            _vm.showSelectedStoryNodesDialog = false
                          }
                        }
                      },
                      [_vm._v("Cancel")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-668c19be", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-668c19be","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/story-edit-view/leftPanel.vue
// module id = null
// module chunks = 